import type { Embodiment, EndEffector, Tip } from "@/api";

// embodiment 표시 포맷의 공용 SoT 다. 리뷰 큐/상세·데이터셋 상세·상세 모달이 같은 표현을 쓴다.
// 팔 구성은 여기 없다. 팔 구성은 Dataset 이 실측 채널로 판정하는 축이므로 `formatArmLayout` 이 소유한다.

// embodiment 식별 라인이다. name 이 유일한 식별자다.
export function formatEmbodimentName(embodiment: Embodiment): string {
  return embodiment.name;
}

// name:tag 공용 표기다. 부품 카탈로그(EndEffector·Tip)는 tag 로 세대를 구분하고 같은 규칙으로 표시한다.
// 이름이 없거나 비어 있으면 "-" 다.
function formatNameTag(part: { name: string; tag: string | null } | null | undefined): string {
  const name = part?.name?.trim();
  if (!name) {
    return "-";
  }
  return part?.tag ? `${name}:${part.tag}` : name;
}

// End effector 표기의 공용 SoT 다: `name:tag`(tag 없으면 name, 둘 다 없으면 "-"). 모든 EE 표시 위치가 공유한다.
export function formatEndEffector(
  endEffector: Pick<EndEffector, "name" | "tag"> | null | undefined,
): string {
  return formatNameTag(endEffector);
}

// Tip 표기의 공용 SoT 다. Tip 은 EE 와 독립인 데이터셋 축이지만 표기는 같은 `name:tag` 규칙을 쓴다.
export function formatTip(tip: Pick<Tip, "name" | "tag"> | null | undefined): string {
  return formatNameTag(tip);
}

// embodiment 부가 정보 한 줄이다. 지금은 EE 만 있다. 빈 항목은 건너뛴다.
export function formatEmbodimentMeta(embodiment: Embodiment): string {
  const parts: string[] = [];
  if (embodiment.end_effector?.name) {
    parts.push(`EE: ${formatEndEffector(embodiment.end_effector)}`);
  }
  return parts.join(" · ");
}
